import { render, staticRenderFns } from "./VatRateFilter.vue?vue&type=template&id=cc3e4b76&"
import script from "./VatRateFilter.vue?vue&type=script&lang=js&"
export * from "./VatRateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports